import Cables from "../classes/Cable"

export const cables = [
  new Cables({
    alias: "conductor-electrico-a",
    svgSrc: "/symbol-assets/CableA.svg",
    label: "Cable",
    rotable: true,
    variants: [
      {
        alias: "conductor-electrico-a",
        diagramSvgSrc: "/symbol-assets/CableA.svg",
        label: "Cable",
        selected: false
      },
      {
        alias: "conductor-electrico-b",
        diagramSvgSrc: "/symbol-assets/CableB.svg",
        label: "Cable B",
        selected: false
      },
      {
        alias: "conductor-electrico-c",
        diagramSvgSrc: "/symbol-assets/CableC.svg",
        label: "Cable C",
        selected: false
      },
      {
        alias: "conductor-electrico-d",
        diagramSvgSrc: "/symbol-assets/CableD.svg",
        label: "Cable D",
        selected: false
      },
      {
        alias: "conductor-electrico-e",
        diagramSvgSrc: "/symbol-assets/Electroducto.svg",
        label: "Cable E",
        selected: false
      },
      {
        alias: "conductor-electrico-f",
        diagramSvgSrc: "/symbol-assets/CableFalso.svg",
        label: "Cable F",
        selected: false
      }
    ]
  }),
];
